module.exports = __webpack_public_path__ + "static/media/registrationBanner.7187815b.png";